import { Box, Link, Typography } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailIcon from "@mui/icons-material/Email";

const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#0a0a0a",
        padding: { xs: "40px 24px", md: "60px 80px" },
        color: "#fff",
      }}
    >
      {/* Main footer content */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "40px",
        }}
      >
        {/* Left side — Logo, Social Icons, Copyright */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {/* Logo */}
          <Typography
            sx={{
              fontFamily: "'Courier New', monospace",
              fontSize: "22px",
              fontWeight: 700,
              color: "#00d4d4",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {/* Replace this span with your actual logo/icon component */}
            <span style={{ fontSize: "28px" }}>꩜</span>
            OmMuse
          </Typography>

          {/* Social Icons */}
          <Box sx={{ display: "flex", gap: "16px" }}>
            <Link
              target="_blank"
              href="https://www.instagram.com/ommuse.music/"
              sx={{ color: "#fff", "&:hover": { color: "#00d4d4" } }}
            >
              <InstagramIcon sx={{ fontSize: 22 }} />
            </Link>
            <Link
              target="_blank"
              href="https://www.facebook.com/ommuse.music"
              sx={{ color: "#fff", "&:hover": { color: "#00d4d4" } }}
            >
              <FacebookIcon sx={{ fontSize: 22 }} />
            </Link>
            <Link
              target="_blank"
              href="https://www.youtube.com/@ommuse"
              sx={{ color: "#fff", "&:hover": { color: "#00d4d4" } }}
            >
              <YouTubeIcon sx={{ fontSize: 22 }} />
            </Link>
            <Link
              href="mailto:hello@ommuse.com"
              sx={{ color: "#fff", "&:hover": { color: "#00d4d4" } }}
            >
              <EmailIcon sx={{ fontSize: 22 }} />
            </Link>
          </Box>

          {/* Copyright */}
          <Typography
            sx={{
              fontSize: "13px",
              color: "#888",
              marginTop: "8px",
            }}
          >
            © 2026. All Rights Reserved
          </Typography>
        </Box>

        {/* Right side — Two columns of nav links */}
        <Box sx={{ display: "flex", gap: { xs: "48px", md: "80px" } }}>
          {/* Column 1 */}
          {/*
            These used to be `["Features","Explore","Pricing","Enterprise"]` with
            the href derived as `/${label.toLowerCase()}` -- a naming convention
            standing in for routing. Three of the four resolved to no route at
            all, and the catch-all sends an anonymous visitor to /welcome, so on
            the Welcome page itself the links silently reloaded the same screen.

            "Features" and "Pricing" are gone rather than repointed: neither
            exists in this app or on the marketing site. /pricing-table is the
            nearest thing and it is behind auth, so it bounces logged-out
            visitors straight back here. Re-add them when there is a page.
          */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
            {[
              { label: "Explore", href: "/explore" },
              // Lives on the marketing site, not here -- same as Accessibility
              // below. ommuse.com stopped being Framer on 2026-09-16 and now
              // serves this page from our own distribution.
              { label: "Enterprise", href: "https://ommuse.com/enterprise" },
            ].map(({ label, href }) => (
              <Link
                key={label}
                href={href}
                underline="none"
                sx={{
                  color: "#ccc",
                  fontSize: "14px",
                  transition: "color 0.2s",
                  "&:hover": { color: "#00d4d4" },
                }}
              >
                {label}
              </Link>
            ))}
          </Box>

          {/* Column 2 */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
            {[
              { label: "Enterprise Addendum", href: "/enterprise-addendum" },
              { label: "Privacy", href: "/privacy-policy" },
              { label: "Terms", href: "/terms-of-use" },
              // The app defines no /accessibility route and never has; the marketing
              // site is where the statement actually lives.
              { label: "Accessibility", href: "https://ommuse.com/accessibility" },
            ].map(({ label, href }) => (
              <Link
                key={label}
                href={href}
                underline="none"
                sx={{
                  color: "#ccc",
                  fontSize: "14px",
                  transition: "color 0.2s",
                  "&:hover": { color: "#00d4d4" },
                }}
              >
                {label}
              </Link>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;